/* The Sleep Co / mattress PDP, technical direction.
   Variant resolution, cross product feel links, delivery add-ons, AJAX cart.

   FIXES:
   - Mattress + delivery + valid recycle option are added together.
   - Hidden recycling is never added to cart.
   - Hidden recycling is never included in total.
   - Sticky ATC uses the same cart logic as main ATC.
   - Sticky ATC appears only after the entire product hero/info area ends.
   - Prevents rapid double adds on mobile Safari.
   - Redirects directly to /cart after successful addition.
   - All DOM queries are scoped to the current Shopify section.
*/

(function () {
  'use strict';


  /* =========================================================
     PRODUCT DATA
     ========================================================= */

  var el =
    document.querySelector(
      '[data-mt-data]'
    );


  if (!el) {
    return;
  }


  var D;


  try {

    D =
      JSON.parse(
        el.textContent
      );

  } catch (e) {

    return;

  }


  /* =========================================================
     CURRENT SHOPIFY SECTION
     ========================================================= */

  var section =
    el.closest('.shopify-section') ||
    document;


  /* =========================================================
     ELEMENTS
     ========================================================= */

  var form =
    section.querySelector('#mtf');


  var idIn =
    section.querySelector(
      '[data-variant-id]'
    );


  var priceE =
    section.querySelector(
      '[data-price]'
    );


  var finE =
    section.querySelector(
      '[data-finance]'
    );


  var subBtn =
    section.querySelector(
      '[data-submit]'
    );


  var subTxt =
    section.querySelector(
      '[data-submit-text]'
    );


  var totalE =
    section.querySelector(
      '[data-total]'
    );


  var stick =
    section.querySelector(
      '[data-stick]'
    );


  var sAdd =
    section.querySelector(
      '[data-stick-add]'
    );


  var sMeta =
    section.querySelector(
      '[data-stick-meta]'
    );


  var sPrice =
    section.querySelector(
      '[data-stick-price]'
    );


  var addons =
    section.querySelector(
      '[data-addons]'
    );


  var recyc =
    section.querySelector(
      '[data-recycle]'
    );


  var groups =
    [].slice.call(
      section.querySelectorAll(
        '[data-opt]'
      )
    );


  /*
   * Full product information area.
   *
   * On mobile, .hero contains BOTH:
   * - gallery
   * - entire buy/product information
   *
   * The sticky bar appears only once this whole
   * section has finished.
   */
  var productInfo =
    section.querySelector('.hero');


  /* =========================================================
     MONEY
     ========================================================= */

  function money(cents) {

    var fmt =
      D.moneyFormat ||
      '£{{amount}}';


    function f(dp) {

      var n =
        (
          cents /
          100
        )
        .toFixed(dp)
        .split('.');


      n[0] =
        n[0].replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ','
        );


      return dp
        ? n.join('.')
        : n[0];
    }


    return fmt

      .replace(
        /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
        f(0)
      )

      .replace(
        /\{\{\s*amount_with_comma_separator\s*\}\}/g,
        f(2)
      )

      .replace(
        /\{\{\s*amount_no_decimals\s*\}\}/g,
        f(0)
      )

      .replace(
        /\{\{\s*amount\s*\}\}/g,
        f(2)
      );
  }


  /* =========================================================
     SELECTED SIZE / CONFIGURATION
     ========================================================= */

  function selected() {

    return groups.map(
      function (g) {

        var b =
          g.querySelector(
            '.opt[aria-pressed="true"]'
          );


        return b
          ? b.getAttribute(
              'data-v'
            )
          : null;
      }
    );
  }


  /* =========================================================
     FIND VARIANT
     ========================================================= */

  function find(
    list,
    opts
  ) {

    for (
      var i = 0;
      i < list.length;
      i++
    ) {

      var v =
        list[i];


      var ok =
        true;


      for (
        var j = 0;
        j < opts.length;
        j++
      ) {

        if (
          opts[j] !== null &&
          v.options[j] !== opts[j]
        ) {

          ok =
            false;

          break;
        }
      }


      if (ok) {
        return v;
      }
    }


    return null;
  }


  /* =========================================================
     ACTIVE DELIVERY / RECYCLE INPUTS
     ========================================================= */

  function activeAddonInputs() {

    if (!addons) {
      return [];
    }


    return [].slice.call(
      addons.querySelectorAll(
        'input:checked'
      )
    )
    .filter(
      function (input) {

        /*
         * If this input belongs to the recycle block,
         * make sure the recycle block is actually visible.
         */
        var recycleWrap =
          input.closest(
            '[data-recycle]'
          );


        if (
          recycleWrap &&
          recycleWrap.hidden
        ) {

          return false;

        }


        return true;
      }
    );
  }


  /* =========================================================
     DELIVERY / RECYCLE PRICE
     ========================================================= */

  function addonTotal() {

    var t =
      0;


    activeAddonInputs()
      .forEach(
        function (input) {

          t +=
            parseInt(
              input.getAttribute(
                'data-add'
              ) ||
              0,
              10
            ) ||
            0;
        }
      );


    return t;
  }


  /* =========================================================
     RECYCLE AVAILABILITY
     ========================================================= */

  function syncRecycleVisibility() {

    if (
      !addons ||
      !recyc
    ) {

      return;

    }


    var trigger =
      recyc.getAttribute(
        'data-trigger'
      );


    var deliveryChoice =
      addons.querySelector(
        'input[name="mt-delivery"]:checked'
      );


    /*
     * If there is no trigger, recycle is always allowed.
     *
     * Otherwise the selected delivery label must match
     * the recycle trigger.
     */
    var show =
      !trigger ||
      (
        deliveryChoice &&
        deliveryChoice.getAttribute(
          'data-label'
        ) === trigger
      );


    recyc.hidden =
      !show;


    var recycleInputs =
      [].slice.call(
        recyc.querySelectorAll(
          'input[name="mt-recycle"]'
        )
      );


    if (!show) {

      /*
       * IMPORTANT FIX:
       *
       * The previous code checked a recycle option
       * even while recycling was hidden.
       *
       * That meant Shopify could receive a hidden
       * recycle product.
       *
       * When recycling is hidden we now clear
       * every recycle radio.
       */
      recycleInputs.forEach(
        function (input) {

          input.checked =
            false;

        }
      );


    } else {

      /*
       * Recycling is allowed again.
       *
       * If no option is currently selected,
       * restore the first/default recycle choice.
       */
      var checked =
        recycleInputs.some(
          function (input) {

            return input.checked;

          }
        );


      if (
        !checked &&
        recycleInputs[0]
      ) {

        recycleInputs[0].checked =
          true;

      }
    }
  }


  /* =========================================================
     RENDER
     ========================================================= */

  function render() {

    var s =
      selected();


    /* ---------------------------------------------------------
       Option availability
       --------------------------------------------------------- */

    groups.forEach(
      function (
        group,
        groupIndex
      ) {

        group.querySelectorAll(
          '.opt'
        )
        .forEach(
          function (button) {

            var test =
              s.slice();


            test[groupIndex] =
              button.getAttribute(
                'data-v'
              );


            var variant =
              find(
                D.variants,
                test
              );


            button.disabled =
              !(
                variant &&
                variant.available
              );
          }
        );
      }
    );


    /* ---------------------------------------------------------
       Feel sibling links
       --------------------------------------------------------- */

    section
      .querySelectorAll(
        '[data-feel-link]'
      )
      .forEach(
        function (a) {

          var handle =
            a.getAttribute(
              'data-handle'
            );


          var sibling =
            D.siblings.filter(
              function (x) {

                return (
                  x.handle ===
                  handle
                );

              }
            )[0];


          if (!sibling) {
            return;
          }


          var variant =
            find(
              sibling.variants,
              s
            ) ||
            find(
              sibling.variants,
              [s[0]]
            );


          a.href =
            variant
              ? sibling.url +
                '?variant=' +
                variant.id
              : sibling.url;
        }
      );


    /* ---------------------------------------------------------
       Current variant
       --------------------------------------------------------- */

    var variant =
      find(
        D.variants,
        s
      );


    if (!variant) {

      if (priceE) {

        priceE.textContent =
          'Not available';

      }


      if (subBtn) {

        subBtn.disabled =
          true;

        subBtn.setAttribute(
          'aria-disabled',
          'true'
        );

      }


      if (sAdd) {

        sAdd.disabled =
          true;

        sAdd.setAttribute(
          'aria-disabled',
          'true'
        );

      }


      if (subTxt) {

        subTxt.textContent =
          'Choose another combination';

      }


      return;
    }


    /* ---------------------------------------------------------
       Variant ID
       --------------------------------------------------------- */

    if (idIn) {

      idIn.value =
        variant.id;

      idIn.disabled =
        false;

    }


    /* ---------------------------------------------------------
       Main price
       --------------------------------------------------------- */

    if (priceE) {

      priceE.textContent =
        money(
          variant.price
        );

    }


    /* ---------------------------------------------------------
       Finance
       --------------------------------------------------------- */

    if (finE) {

      finE.textContent =
        money(
          Math.round(
            variant.price /
            (
              D.financeMonths ||
              6
            )
          )
        );

    }


    /* ---------------------------------------------------------
       Main Add to Bag
       --------------------------------------------------------- */

    if (subBtn) {

      subBtn.disabled =
        !variant.available;


      subBtn.setAttribute(
        'aria-disabled',
        variant.available
          ? 'false'
          : 'true'
      );

    }


    if (subTxt) {

      subTxt.textContent =
        variant.available
          ? 'Add to bag'
          : 'Unavailable';

    }


    /* ---------------------------------------------------------
       Sticky Add to Bag
       --------------------------------------------------------- */

    if (sAdd) {

      sAdd.disabled =
        !variant.available;


      sAdd.setAttribute(
        'aria-disabled',
        variant.available
          ? 'false'
          : 'true'
      );


      sAdd.textContent =
        variant.available
          ? 'Add to bag'
          : 'Unavailable';

    }


    /* ---------------------------------------------------------
       Mattress + delivery + recycle total
       --------------------------------------------------------- */

    var total =
      variant.price +
      addonTotal();


    if (totalE) {

      totalE.textContent =
        money(total);

    }


    if (sPrice) {

      sPrice.textContent =
        money(total);

    }


    /* ---------------------------------------------------------
       Sticky information
       --------------------------------------------------------- */

    if (sMeta) {

      sMeta.textContent =
        [

          D.feel,

          variant.title,

          D.depth
            ? D.depth +
              ' cm'
            : null,

          D.springs
            ? D.springs.toLocaleString(
                'en-GB'
              ) +
              ' springs'
            : null

        ]
        .filter(Boolean)
        .join(' · ');

    }


    /* ---------------------------------------------------------
       URL variant
       --------------------------------------------------------- */

    if (
      window.history &&
      window.history.replaceState
    ) {

      var u =
        new URL(
          window.location.href
        );


      u.searchParams.set(
        'variant',
        variant.id
      );


      window.history.replaceState(
        {},
        '',
        u.toString()
      );
    }
  }


  /* =========================================================
     SIZE / CONFIGURATION CLICKS
     ========================================================= */

  groups.forEach(
    function (group) {

      group.addEventListener(
        'click',
        function (e) {

          var button =
            e.target.closest(
              '.opt'
            );


          if (
            !button ||
            button.disabled
          ) {

            return;

          }


          group
            .querySelectorAll(
              '.opt'
            )
            .forEach(
              function (other) {

                other.removeAttribute(
                  'aria-pressed'
                );

              }
            );


          button.setAttribute(
            'aria-pressed',
            'true'
          );


          render();
        }
      );
    }
  );


  /* =========================================================
     DELIVERY / RECYCLE CHANGE
     ========================================================= */

  if (addons) {

    addons.addEventListener(
      'change',
      function () {

        syncRecycleVisibility();

        render();

      }
    );


    /*
     * Initialise the correct recycle state immediately.
     */
    syncRecycleVisibility();

  }


  /* =========================================================
     BUILD CART ITEMS
     ========================================================= */

  function items() {

    var variant =
      find(
        D.variants,
        selected()
      );


    if (
      !variant ||
      !variant.available
    ) {

      return null;

    }


    /*
     * Start with mattress.
     */
    var out = [

      {
        id: variant.id,
        quantity: 1
      }

    ];


    /*
     * Add selected delivery.
     *
     * Add recycle only when recycle is visible.
     */
    activeAddonInputs()
      .forEach(
        function (input) {

          var id =
            parseInt(
              input.value,
              10
            );


          if (id) {

            out.push({

              id: id,
              quantity: 1

            });

          }
        }
      );


    return out;
  }


  /* =========================================================
     DOUBLE TAP / AJAX STATE
     ========================================================= */

  var busy =
    false;


  function setBusy(on) {

    busy =
      on;


    if (on) {

      if (subBtn) {

        subBtn.disabled =
          true;

      }


      if (sAdd) {

        sAdd.disabled =
          true;

      }


      if (subTxt) {

        subTxt.textContent =
          'Adding';

      }


      if (sAdd) {

        sAdd.textContent =
          'Adding';

      }


    } else {

      render();

    }
  }


  /* =========================================================
     ADD TO CART
     ========================================================= */

  function add() {

    if (busy) {
      return;
    }


    /*
     * Re-evaluate recycle immediately before building
     * cart payload.
     */
    syncRecycleVisibility();


    var list =
      items();


    if (!list) {

      render();

      return;

    }


    setBusy(true);


    var root =
      (
        window.Shopify &&
        window.Shopify.routes
      )
        ? window.Shopify.routes.root
        : '/';


    /*
     * ONE Shopify request containing:
     *
     * 1. Mattress
     * 2. Selected delivery product
     * 3. Recycling product only when applicable
     */
    fetch(
      root + 'cart/add.js',
      {

        method:
          'POST',

        headers: {

          'Content-Type':
            'application/json',

          'Accept':
            'application/json',

          'X-Requested-With':
            'XMLHttpRequest'

        },

        body:
          JSON.stringify({

            items:
              list

          })

      }
    )

    .then(
      function (response) {

        return response
          .json()
          .then(
            function (body) {

              return {

                ok:
                  response.ok,

                body:
                  body

              };

            }
          );

      }
    )

    .then(
      function (res) {

        if (!res.ok) {

          throw new Error(
            res.body.description ||
            'Could not add to bag'
          );

        }


        if (subTxt) {

          subTxt.textContent =
            'Added';

        }


        if (sAdd) {

          sAdd.textContent =
            'Added';

        }


        /*
         * Product + delivery + recycling are now all
         * successfully in Shopify.
         *
         * Go directly to the cart page.
         */
        window.location.assign(
          root + 'cart'
        );

      }
    )

    .catch(
      function (err) {

        if (subTxt) {

          subTxt.textContent =
            err.message;

        }


        if (sAdd) {

          sAdd.textContent =
            err.message;

        }


        setTimeout(
          function () {

            setBusy(false);

          },
          2200
        );

      }
    );
  }


  /* =========================================================
     MAIN ADD TO BAG
     ========================================================= */

  if (form) {

    form.addEventListener(
      'submit',
      function (e) {

        e.preventDefault();

        add();

      }
    );

  }


  /* =========================================================
     STICKY ADD TO BAG
     ========================================================= */

  if (sAdd) {

    sAdd.addEventListener(
      'click',
      function (e) {

        e.preventDefault();


        if (
          sAdd.disabled ||
          busy
        ) {

          return;

        }


        /*
         * Exact same add function as main ATC.
         */
        add();

      }
    );

  }


  /* =========================================================
     GALLERY
     ========================================================= */

  var thumbs =
    section.querySelectorAll(
      '[data-thumb]'
    );


  var slides =
    section.querySelectorAll(
      '[data-slide]'
    );


  var count =
    section.querySelector(
      '[data-count]'
    );


  thumbs.forEach(
    function (thumb) {

      thumb.addEventListener(
        'click',
        function () {

          var index =
            parseInt(
              thumb.getAttribute(
                'data-thumb'
              ),
              10
            );


          thumbs.forEach(
            function (other) {

              other.setAttribute(
                'aria-selected',
                'false'
              );

            }
          );


          thumb.setAttribute(
            'aria-selected',
            'true'
          );


          slides.forEach(
            function (
              slide,
              slideIndex
            ) {

              slide.hidden =
                slideIndex !==
                index;


              if (
                slideIndex !==
                index
              ) {

                var video =
                  slide.querySelector(
                    'video'
                  );


                if (video) {

                  video.pause();

                }
              }

            }
          );


          if (count) {

            count.textContent =
              index +
              1;

          }

        }
      );

    }
  );


  /* =========================================================
     STICKY BAR VISIBILITY
     ========================================================= */

  /*
   * IMPORTANT:
   *
   * We intentionally use the full .hero.
   *
   * We DO NOT use:
   *
   *   document.querySelector('.buy')
   *
   * because on mobile .buy can finish before the entire
   * gallery + product information area.
   *
   * Sticky appears only once the full hero has moved
   * completely above the viewport.
   */
  if (
    stick &&
    productInfo
  ) {

    var ticking =
      false;


    function updateSticky() {

      ticking =
        false;


      var rect =
        productInfo
          .getBoundingClientRect();


      var show =
        rect.bottom <=
        0;


      stick.setAttribute(
        'data-on',
        show
          ? 'true'
          : 'false'
      );
    }


    /*
     * Mobile Safari:
     *
     * avoid doing layout work for every single scroll event.
     */
    function requestStickyUpdate() {

      if (ticking) {
        return;
      }


      ticking =
        true;


      window.requestAnimationFrame(
        updateSticky
      );
    }


    window.addEventListener(
      'scroll',
      requestStickyUpdate,
      {
        passive: true
      }
    );


    window.addEventListener(
      'resize',
      requestStickyUpdate
    );


    window.addEventListener(
      'orientationchange',
      requestStickyUpdate
    );


    /*
     * Make sure the bar starts in the correct state.
     */
    updateSticky();


  } else if (stick) {

    stick.setAttribute(
      'data-on',
      'false'
    );

  }


  /* =========================================================
     INITIAL STATE
     ========================================================= */

  render();

})();